import './App.css';
import React from 'react';
import Home from "./pages/Home.js";
import Drawings from "./pages/Drawings.js";
import Presentations from "./pages/Presentations.js";
import Objects from "./pages/Objects.js";
import Ideas from "./pages/Ideas.js";
import { Switch, Route } from "react-router-dom";

function App() {
  return (
    <div className="home-navigation">
      <Switch>
        <Route path="/" exact>
          <Home />
        </Route>
        <Route path="/blind-drawings" exact>
          <Drawings />
        </Route>
        <Route path="/improv-presentations" exact>
          <Presentations />
        </Route>
        <Route path="/random-objects" exact>
          <Objects />
        </Route>
        <Route path="/idea-generator" exact>
          <Ideas />
        </Route>
      </Switch>
    </div>
  );
}

export default App;
